<template>
    <v-app-bar
        class="main-header"
        height="50"
        fixed
        color='primary'
        dark>
        <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
            <template v-if="DRAWER_STATE">
               <v-icon size="28">menu_open</v-icon>
            </template>
            <template v-else>
                <v-icon size="28" class="rotate-180">menu_open</v-icon>
            </template>
        </v-btn>
        <v-toolbar-title class="text-h4">{{$store.state.appName}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <p class="mt-5 text_username">{{ personaModel.nombre }} {{ personaModel.apellido }}</p>
        <campana-notificaciones/>
        <v-menu
            min-width="180"
            offset-y
            bottom
            left
            nudge-bottom="10">

            <template v-slot:activator="{ on, attrs }">

                <v-btn
                    class="mr-0"
                    icon
                    v-bind="attrs"
                    v-on="on">
                    <v-avatar v-if="fotoUrl" size="38" class="avatar-sesion">
                        <img :src="fotoUrl" alt="Mi fotografía">
                    </v-avatar>
                    <v-icon v-else size="40">
                        account_circle
                    </v-icon>
                </v-btn>

            </template>
            <v-list>
                <v-list-item-group color="primary"
                                   v-show="personaModel.cat_tipo_persona_id == 1 || personaModel.cat_tipo_persona_id == 2">
                    <v-list-item to="/mi_perfil">
                        <v-list-item-icon class="mr-4">
                            <v-icon>
                                assignment_ind
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title :color='config.light.textColor'>Mi Perfil</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item to="/cambiar_password">
                        <v-list-item-icon class="mr-4">
                            <v-icon>
                                lock_reset
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title :color='config.light.textColor'>Cambiar contraseña</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
                <div class="d-flex justify-center my-3">
                    <v-btn
                        width="80%"
                        outlined
                        color="info"
                        class="text-capitalize"
                        @click="logOut">
                        <v-icon>logout</v-icon>
                        Salir
                    </v-btn>
                </div>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import config from '../../config';

import Auth from "@/services/auth";
import Ls from "@/services/ls";
import CampanaNotificaciones from "@/components/Notificaciones/CampanaNotificaciones.vue";

export default {
    name: 'Header',
    components: {CampanaNotificaciones},
    data: () => ({
        config,
        fotoUrl: null,
        personaModel: {
            cat_tipo_persona_id: Ls.get('tipo_persona'),
            nombre: Ls.get('nombre'),
            apellido: Ls.get('apellido')
        },
    }),
    computed: {
        ...mapState(['drawer']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    created() {
        this.cargarFoto();
        this.$root.$on("foto-perfil-cambiada", this.cargarFoto);
    },
    beforeDestroy() {
        this.$root.$off("foto-perfil-cambiada", this.cargarFoto);
    },
    methods: {
        ...mapActions(['TOGGLE_DRAWER']),
        // Solo las cuentas administrativas tienen fotografía de perfil.
        cargarFoto() {
            if (Number(this.personaModel.cat_tipo_persona_id) === 3) return;

            window.axios.get('/usuarios/info').then(response => {
                this.fotoUrl = response.data.success && response.data.data ? response.data.data.foto_url : null;
            }).catch(() => {});
        },
        logOut: function () {
            let tipoPersona = Number(Ls.get("tipo_persona"));
            Auth.logout().then(() => {
                let routeName = (tipoPersona == 1 || tipoPersona == 2) ? "LoginAdmin" : "LoginCertificados";
                this.$router.push({name: routeName});
            })
        }
    }
};
</script>

<style lang="scss" scoped>
@import './Header.scss';
</style>
